/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Moreactions1Inputs */

const zh_sidebar_moreactions1 = /** @type {(inputs: Sidebar_Moreactions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多操作`)
};

const en_sidebar_moreactions1 = /** @type {(inputs: Sidebar_Moreactions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More Actions`)
};

const es_sidebar_moreactions1 = /** @type {(inputs: Sidebar_Moreactions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más acciones`)
};

/**
* | output |
* | --- |
* | "More Actions" |
*
* @param {Sidebar_Moreactions1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const sidebar_moreactions1 = /** @type {((inputs?: Sidebar_Moreactions1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Moreactions1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_moreactions1(inputs)
	if (locale === "en") return en_sidebar_moreactions1(inputs)
	return es_sidebar_moreactions1(inputs)
});
export { sidebar_moreactions1 as "sidebar_moreActions" }